import { render } from "./LocaleChanger.vue?vue&type=template&id=5181e1c8&scoped=true&ts=true"
import script from "./LocaleChanger.vue?vue&type=script&lang=ts"
export * from "./LocaleChanger.vue?vue&type=script&lang=ts"

import "./LocaleChanger.vue?vue&type=style&index=0&id=5181e1c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5181e1c8"]])

export default __exports__